<template>
  <div class="dialog-wrap">
    <el-dialog title="角色管理"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="680px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="名称"
                      prop="title">
          <el-input v-model="dataForm.title"
                    placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="范围"
                      prop="datarange">
          <el-select v-model="dataForm.datarange"
                     placeholder="请选择"
                     clearable>
            <el-option label="本人"
                       :value="1">
            </el-option>
            <el-option label="本部门"
                       :value="2">
            </el-option>
            <el-option label="本部门及下属部门"
                       :value="3">
            </el-option>
            <el-option label="全部"
                       :value="4">
            </el-option>
            <el-option label="本人产品"
                       :value="5">
            </el-option>
            <el-option label="新媒体账号"
                       :value="6">
            </el-option>
            <el-option label="本人专业数据范围"
                       :value="7">
            </el-option>
            <el-option label="本人邀请用户数据范围"
                       :value="8">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择账号"
                      prop="media_account_ids"
                      v-if="dataForm.datarange==6">
          <el-link type="primary"
                   :underline="false"
                   @click="accountChooseDialog=true">选择账号</el-link>
          <div class="tags-wrap">
            <el-tag :key="index"
                    v-for="(item,index) in accounts"
                    closable
                    :disable-transitions="false"
                    @close="handleTagRemove(item)">
              {{item.name}}/{{formatePlatform_code(item.platform_code)}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="备注"
                      prop="remark">
          <el-input v-model="dataForm.remark"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <AccountChoose :visible="accountChooseDialog"
                   :content="accounts"
                   @close="accountChooseDialog = false"
                   @submit="saveAccounts"></AccountChoose>
  </div>
</template>

<script>
import AccountChoose from '@/components/dialog/select/AccountChoose'
import { adminRoleCreate } from '@/api/admin'

export default {
  components: {
    AccountChoose,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        datarange: [{ required: true, message: '请选择范围', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        media_account_ids: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.accounts.length) {
                callback(new Error('请选择新媒体账号'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      accountChooseDialog: false,
      accounts: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, {
            media_account_ids: this.accounts.length
              ? this.accounts
                  .map((v) => {
                    return v.id
                  })
                  .join(',')
              : '',
          })
          adminRoleCreate(params)
            .then((res) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()
              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    saveAccounts(data) {
      this.accounts = data
    },
    handleTagRemove(item) {
      this.accounts = this.accounts.filter((v) => v.id !== item.id)
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: '小红书',
        2: '公众号',
        3: '微博',
        /*    4: "B站", */
        5: '知乎',
        /*      6: "抖音", */
      }
      return platform_code[val] || ''
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
.tags-wrap {
  .el-tag {
    margin: 4px;
  }
}
</style>
